import React from "react";

export default () => <main className="page__main-holder" role="main"/>